import type { FC } from 'react';
import Lockr from 'lockr';
import { StorageKeys } from '../../utils/storageKeys';

const dayjs = require("dayjs")
const utc = require("dayjs/plugin/utc")
const timezone = require("dayjs/plugin/timezone")

interface FormattedDateProps {
    dateValue?: string;
    isRecurrent?: boolean;
    ignoreTimezone?: boolean;
    isValueUTC?: boolean;
    format?: string; // Optional explicit format override
}

const FormattedDate: FC<FormattedDateProps> = (props) => {
    const defaultFormat = props.isRecurrent ? 'DD/MM HH:mm' : 'DD/MM/YYYY HH:mm';
    const fmt = props.format ? props.format : defaultFormat;
    if (props.ignoreTimezone){
        return (
            <>
                {dayjs(props.dateValue).format(fmt)}
            </>
        );
    }

    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.tz.setDefault()

    const appTimezone = Lockr.get<string>(StorageKeys.Timezone) || Intl.DateTimeFormat().resolvedOptions().timeZone;

    let dayjsDate: any;
    if(props.isValueUTC) {
        dayjsDate = dayjs.utc(props.dateValue);
    }
    else {
        dayjsDate = dayjs(props.dateValue).utc()
    }

    return (
        <>
            {dayjsDate.tz(appTimezone).format(fmt)}
        </>
    );
};

export default FormattedDate;